<script>
export default {
	props: ['client'],
};
</script>

<template>
	<div>
		<p class="text-ternary-dark dark:text-ternary-light">{{ client.title }}</p>
		<div class="flex items-center justify-center">
			<img
				:src="client.img"
				:alt="client.title"
				class="w-[150px] py-2 px-10 rounded-lg mb-8 cursor-pointer "
			/>
		</div>
	</div>
</template>

